module.exports = __webpack_public_path__ + "media/img/apple-icon-180x180-ef05900f71d21af2b00ae0cc76bb8266.png";